import { createFileRoute } from '@tanstack/react-router'

import { CustomerHomePage } from '../../../../components/pages/customer-home-page/customer-home-page.tsx'

export const Route = createFileRoute('/(customer)/_portal/home')({
  component: () => <CustomerHomePage />,
})
